import ApiClient from "../api/apiClient";

const APPEALS = "/appeals/";
const BULK_UPDATE_APPEAL = "/appeals/update-multiple-appeals";
const APPEAL_COUNT = "/appeals/get-appeal-status-count";

const getAppeals = ({
  page,
  limit,
  certificate_type,
  start_date,
  end_date,
  full_name,
  registered_from,
  registered_to,
  technology_field,
  identity_number,
  payment_from,
  payment_to,
  search,
  board_approval_from,
  board_approval_to,
  filter_status,
  registration_no,
  email,
}) => {
  const baseUrl = `${APPEALS}?`;

  let queryParams = "";

  // Add mandatory parameters
  queryParams += `page=${page}&limit=${limit}&certificate_type=${certificate_type}`;

  // Add optional parameters if present
  if (full_name) queryParams += `&full_name=${full_name}`;
  if (email) queryParams += `&email=${email}`;
  if (registered_from) queryParams += `&registered_from=${registered_from}`;
  if (registered_to) queryParams += `&registered_to=${registered_to}`;
  if (technology_field) queryParams += `&technology_field=${technology_field}`;
  if (identity_number) queryParams += `&identity_number=${identity_number}`;
  if (payment_from) queryParams += `&payment_from=${payment_from}`;
  if (payment_to) queryParams += `&payment_to=${payment_to}`;
  if (search) queryParams += `&search=${search}`;
  if (start_date) queryParams += `&start_date=${start_date}`;
  if (end_date) queryParams += `&end_date=${end_date}`;
  if (board_approval_from) queryParams += `&board_approval_from=${board_approval_from}`;
  if (board_approval_to) queryParams += `&board_approval_to=${board_approval_to}`;
  if (registration_no) queryParams += `&registration_no=${registration_no}`;
  if (filter_status) queryParams += `&filter_status=${filter_status}`;
  const url = baseUrl + queryParams;

  return ApiClient.get(url);
};

const changeStatus = (id, data) => {
  const url = APPEALS + id;
  return ApiClient.put(url, data);
};

const getStatusCount = ({ search,
  certificate_type,
  full_name,
  registered_from,
  registered_to,
  start_date,
  end_date,
  technology_field,
  identity_number, }) => {
  const baseUrl = `${APPEAL_COUNT}?`;

  let queryParams = "";

  // Add optional parameters if present
  if (certificate_type) queryParams += `&certificate_type=${certificate_type}`
  if (registered_from) queryParams += `&registered_from=${registered_from}`;
  if (registered_to) queryParams += `&registered_to=${registered_to}`;
  if (identity_number) queryParams += `&identity_number=${identity_number}`;
  if (search) queryParams += `&search=${search}`;
  if (technology_field) queryParams += `&technology_field=${technology_field}`;
  if (full_name) queryParams += `&full_name=${full_name}`;
  if (start_date) queryParams += `&start_date=${start_date}`;
  if (end_date) queryParams += `&end_date=${end_date}`;

  const url = baseUrl + queryParams;

  return ApiClient.get(url);
}

const getAppeal = (id) => {
  const url = APPEALS + id;
  return ApiClient.get(url);
};

const changeBulkAppealStatus = (data) => {
  const url = BULK_UPDATE_APPEAL;
  return ApiClient.patch(url, data);
};

export const appealsService = {
  getAppeals,
  changeStatus,
  getAppeal,
  getStatusCount,
  changeBulkAppealStatus
};
